import {
  createVideoImageBox,
  createNewsBox,
} from "@/js/ComponentJs/ShortImageContainer.js";
import "@/css/News/index.css";
import { openVideo, closeVideo } from "@/js/video.js";
import { get } from "@/js/request.js";

//获取是否为底部方法
function getScrollTop() {
  var scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    //兼容ie
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop =
    bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}
//获取可滚动高度
function getScrollHeight() {
  var scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    //兼容ie
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight =
    bodyScrollHeight - documentScrollHeight > 0
      ? bodyScrollHeight
      : documentScrollHeight;
  return scrollHeight;
}
//获取可见区域高
function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    //兼容ie
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}
//c参数
var page = 1;
var videoPage = 1;
var pageSize = 6;
var activeKey = 1;
var isPageLimit = false;
var isVideoPageLimit = false;
//请求接口
function addItem(page, data, successCallBack) {
  get("/journalism/news-list", { page, pageSize, ...data }, successCallBack);
  page += 1;
}
//事件监听 下拉请求
window.onscroll = function () {
  console.log(activeKey === 1 && !isPageLimit);
  if (
    Math.round(getScrollTop() + getWindowHeight()) == getScrollHeight() &&
    ((activeKey === 1 && !isPageLimit) ||
      (activeKey === 2 && !isVideoPageLimit))
  ) {
    let questPage = activeKey === 1 ? page : videoPage;
    addItem(questPage, { newsType: activeKey }, (res) => {
      if (res.data.list.length < pageSize) {
        activeKey === 1 ? (isPageLimit = true) : (isVideoPageLimit = true);
        if (res.data.list.length === 0) {
          return;
        }
      }

      if (activeKey === 1) {
        createNewsBox(res.data.list, ImageList);
        page += 1;
      } else {
        createVideoImageBox(res.data.list, videoListNode);
        videoPage += 1;
      }
    });
  }
};
//切换方法
var changeKey = function (key) {
  if (activeKey + 1 !== key) {
    activeKey = key + 1;
  } else {
    return;
  }
  var keyItemList = document.querySelectorAll(".keyItem");
  var tabBarList = document.querySelector(".tab-bar-container");
  for (var i = 0; i < keyItemList.length; i++) {
    if (i === key) {
      keyItemList[i].classList.add("active");
      tabBarList.children[i].classList.add("active");
    } else {
      keyItemList[i].classList.remove("active");
      tabBarList.children[i].classList.remove("active");
    }
  }
};
let ImageList = document.querySelector(".image-list-container .shortBoxList ");
let videoListNode = document.querySelector(".videoBox.shortBoxList");
//初次请求
addItem(1, { newsType: 1 }, (res) => {
  createNewsBox(res.data?.list, ImageList);
  page += 1;
});
addItem(1, { newsType: 2 }, (res) => {
  createVideoImageBox(res.data?.list, videoListNode);
  videoPage += 1;
});
//关闭视频
document.querySelector(".clip .close").onclick = function () {
  closeVideo();
};
//切换按钮
let keyItemList = Array.from(document.querySelectorAll(".keyList .keyItem"));
keyItemList.forEach((item, idx) => {
  item.onclick = function () {
    changeKey(idx);
  };
});
